import React from 'react';
import styled from 'styled-components';

import { LiveStreamingDto } from '@/application/interfaces/pegasus.gateway';

const HighlightCardContainer = styled.div`
  display: flex;
  height: 15.25rem;
  padding: 2rem 2.5rem 1.5rem 2.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  color: whitesmoke;

  @media (max-width: 425px) {
    height: 13.25rem;
  }

  position: relative;
  border-radius: 0.5rem;
  ::before {
    content: '';
    position: absolute;
    aspect-ratio: 16 / 9;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 548px;
    max-height: 244px;
    height: fit-content;

    border-radius: 0.5rem;
    background-image: url(${({ backgroundURL }: { backgroundURL: string }) => backgroundURL});
    background-size: cover;
    background-color: black;
    background-clip: border-box;
    opacity: 0.5;
  }
`;

const InsideContainer = styled.div`
  font-family: Aprova Nova;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 425px) {
    gap: 0.1rem;
  }
`;

const InsideButton = styled.button`
  font-family: Aprova Nova;
  border: none;
  cursor: pointer;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  height: 38px;
  width: 206px;
  border-radius: 300px;
  padding: 0px 24px;
  background-color: #00f99d;
  color: #191a1a;
  top: 1rem;
`;

const HighlightCardIconStatus = styled.span`
  display: block;
  height: 6px;
  width: 6px;
  border-radius: 0.375rem;
  background: var(--feedback-color-error-100, #ff7572);
`;

const HighlightCardStatus = styled.p`
  gap: 0.25rem;
  display: flex;
  align-items: center;
`;

const HighlightCardTextStatus = styled.div`
  font-family: Aprova Nova;
  font-size: 12px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  text-transform: uppercase;
`;

const HighlightCardTitle = styled.h1`
  font-family: Aprova Nova;
  font-size: 32px;
  font-weight: 700;
  line-height: 35px;
  letter-spacing: -1px;
  text-align: left;
`;

const HighlightCardSubtitle = styled.h2`
  font-family: Aprova Nova;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.6px;
  text-align: left;
  margin-top: 0.75rem;
`;

interface HighlightCard {
  backgroundURL?: string;
  status: string;
  title: string;
  subtitle?: string;
  liveStreaming?: LiveStreamingDto;
}

const getLiveLessonUrl = (courseGuid: string, streamingGuid: string) => {
  return `/classroom/live/course/${courseGuid}/${streamingGuid}`;
};

const HighlightLiveItem = ({
  backgroundURL,
  status,
  title,
  subtitle,
  liveStreaming,
  ...props
}: HighlightCard) => (
  <HighlightCardContainer
    className="highlight-card-container"
    backgroundURL={backgroundURL}
    {...props}
  >
    <InsideContainer>
      <HighlightCardStatus>
        <HighlightCardIconStatus />
        <HighlightCardTextStatus>{status}</HighlightCardTextStatus>
      </HighlightCardStatus>
      <HighlightCardTitle>{title}</HighlightCardTitle>
      <HighlightCardSubtitle>{subtitle}</HighlightCardSubtitle>
      <InsideButton
        onClick={() =>
          (window.location.href = getLiveLessonUrl(
            liveStreaming.course.guid,
            liveStreaming.streaming.guid,
          ))
        }
      >
        Assistir Agora
      </InsideButton>
    </InsideContainer>
  </HighlightCardContainer>
);

export default HighlightLiveItem;
